import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  formWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: SPACES.xxxl,

      padding: SPACES.xxl,

      width: '320px',
      minHeight: '300px',
    },
  },
  upperWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: SPACES.xxl,

      width: '100%',
    },
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.xxl,
      fontWeight: FONTS.WEIGHTS.bold,
      lineHeight: 1.4,
      textAlign: 'center',

      color: theme.palette.custom.darkBlue2,
    },
  },
  inputLabel: {
    '&&': {
      color: theme.palette.custom.darkBlue2,

      fontSize: FONTS.SIZES.m,
      lineHeight: 1.4,
    },
  },
}))
